import React from "react";

const RetiredBadge = () => {
  return (
    <div className="bg-alert-10 w-[60px] py-1 px-2 font-poppins font-medium text-xs text-alert-red rounded-md">
      Retired
    </div>
  );
};

export default RetiredBadge;
